export enum PermissionRole {
  ACCESS = 'engo.access',
  ADMIN = 'engo.admin',
  TASKS_RELEASE = 'engo.tasks.release',
  TASKS_VIEW_ALL = 'engo.tasks.view.all',
  TASKS_VIEW_MY = 'engo.tasks.view.my',
  TASKS_RECEIVE = 'engo.tasks.receive',
  TASKS_APPROVE = 'engo.tasks.approve',
  TASKS_EDIT = 'engo.tasks.edit',
  DATA_VIEW = 'engo.data.view',
  MULTI_APPROVE = 'engo.tasks.multi-approve',
  TASKS_RECEIVE_PRO = 'engo.tasks.receive-pro',
}
